import {
  ExternalPayoutStatus,
  IPayoutInfluencer,
} from "@shared/lib/types/briefCampains";

export function getVendorPaymentId(record: IPayoutInfluencer): string {
  return record.vendorPaymentId || record._id;
}

export function canCancelPayout(record: IPayoutInfluencer): boolean {
  return (
    record.externalPayoutStatus === ExternalPayoutStatus.Pending ||
    record.externalPayoutStatus === ExternalPayoutStatus.Queued
  );
}

export function formatPayoutAmount(amount?: number): string {
  if (amount == null || Number.isNaN(Number(amount))) {
    return "—";
  }
  return `₹${Number(amount).toLocaleString("en-IN")}`;
}

export function formatPayoutDate(iso?: string): string {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function maskAccountNumber(accountNumber?: string): string {
  if (!accountNumber) return "";
  return accountNumber.length <= 4
    ? accountNumber
    : `••••${accountNumber.slice(-4)}`;
}

export function getExternalPayoutStatusLabel(
  status?: ExternalPayoutStatus
): string {
  if (status === ExternalPayoutStatus.Success) return "Paid";
  return status || "—";
}

export function getExternalPayoutStatusTone(
  status?: ExternalPayoutStatus
): "pending" | "queued" | "processing" | "success" | "failed" | "cancelled" {
  switch (status) {
    case ExternalPayoutStatus.Queued:
      return "queued";
    case ExternalPayoutStatus.Processing:
      return "processing";
    case ExternalPayoutStatus.Success:
      return "success";
    case ExternalPayoutStatus.Failed:
      return "failed";
    case ExternalPayoutStatus.Cancelled:
      return "cancelled";
    default:
      return "pending";
  }
}

export function getPayoutUtr(record: IPayoutInfluencer): string | undefined {
  return record.externalUtrNo || undefined;
}
